import {Action} from '@ngrx/store';
import {BijbEvent} from '../../../models/bijb-event';

export class GetDressCodeAction implements Action {
  public static readonly type = 'GetDressCodeAction';

  constructor(public bijbEvent: BijbEvent) {
  }

  public type = GetDressCodeAction.type;
}
